import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export function DeactivateMonitoringConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
}: Props) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen testID="deactivate-monitoring-confirm-modal">
      <Dialog>
        <DialogHeader onClose={onClose}>
          {t("Deactivate monitoring")}
        </DialogHeader>
        <DialogContent>
          {t(
            "Once monitoring has been deactivated for an applicant it cannot be reinstated for the same base check(s). Are you sure you want to continue?"
          )}
        </DialogContent>
        <DialogFooter>
          <BasicButton
            onPress={onClose}
            isDisabled={isSubmitting}
            testID="deactivate-monitoring-cancel-button"
          >
            {t("No")}
          </BasicButton>
          <DangerButton
            onPress={onConfirm}
            isDisabled={isSubmitting}
            testID="deactivate-monitoring-confirm-button"
          >
            {t("Yes")}
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
